<template>
    <div v-if='user' class="patient-banner">
        <!-- <h5 v-if="thread == null">
            <span style='white-space: nowrap;'><strong>{{formatNameCompliant(this.$root.user)}}</strong></span>
            <span style='white-space: nowrap;'>Born: <strong>{{this.$root.user.dob | formatDate}} <template v-if='this.$root.user.dob'>({{this.$root.user.dob | getAge}}y)</template></strong></span>
            <span style='white-space: nowrap;'>Gender: <strong>{{getGender(this.$root.user.gender)}}</strong></span>
            <span style='white-space: nowrap;'>{{$t('translations.NHS_number')}}: <strong>{{this.$root.user.nhs_number}}</strong></span>
        </h5> -->
        <h5>
            <span style='white-space: nowrap;'><strong>{{formatNameCompliant(user)}}</strong></span>
            <span style='white-space: nowrap;' class="DOB"><em>{{ $t('translations.born') }}</em> <strong><span class="copyDOB" v-on:click.prevent="copyDOB(formatDate(user.dob))">{{user.dob | formatDate}}</span> <template v-if='user.dob'>({{user.dob | getAge}})</template></strong></span>
            <span style='white-space: nowrap;'><em>{{ $t('translations.gender') }}</em> <strong>{{getGender(user.gender)}}</strong></span>
            <span style='white-space: nowrap;'><em>{{ $t('translations.NHS_number')}}</em> <strong v-if="user.nhs_number" v-on:click="copyTextContent((user.nhs_number).replace(/[^A-Z0-9]/ig, ''))" class="copyTextContent">{{user.nhs_number.replace(/(.{3})/,"$1&nbsp;").replace(/(.{7})/,"$1&nbsp;")}}</strong></span>
        </h5>
        <h5 v-if="show_zone_2">
            <span style='white-space: nowrap;'>{{ $t('translations.address') }} <strong>{{this.formatAddress(user.address_line_1, user.address_line_2, user.address_line_3,user.address_line_4,user.postcode)}}</strong></span>
            <span style='white-space: nowrap;'>{{ $t('translations.phone_and_email') }} <strong>{{user.phone_number}}, {{user.email}}</strong></span>
        </h5>
        <div style="display:flex;align-items:center">
            <div v-if='user && user.valid_oauth_access_token' class="icon--app-paired" v-b-tooltip :title="autobrand('translations.egl_app_paired')"></div>
            <div v-if='user && user.nhs_login' class="icon--app-nhs-login" v-b-tooltip :title="autobrand('translations.has_nhs_login')"></div>
        </div>
    </div>
</template>


<script>
	export default {
		props: {
            user: {
                
            },
            showClose: {
                default: false,
            }
            
        },
		data: function(){
			return {
                show_zone_2: false,
			};
		},
        mounted() {
        },
		computed: {

		},
		watch: {

		},
		methods: {
            copyDOB(html) {
				var container = document.createElement('div');
				container.innerHTML = html;
				document.body.appendChild(container);
				window.getSelection().removeAllRanges();
				var range = document.createRange();
				range.selectNode(container);
				window.getSelection().addRange(range);
				document.execCommand('copy');
				document.body.removeChild(container);
				this.addNotification({type: "success", content: this.$t('translations.date_of_birth_copied_to_clipboard')});
			},
        }
	}
</script>